<template>
  <div class="fixed-aside-box">
    <!-- <div class="aside-item wechat">
      <div class="aside-imgs"></div>
      <div class="aside-txt">微信</div>
      <div class="position-sub">
        <div class="position-img"></div>
      </div>
    </div> -->
    <div class="aside-item phone">
      <div class="aside-imgs"></div>
      <div class="aside-txt">服务<br />咨询</div>
      <div class="position-service">
        <div class="service-left">
          <div class="service-title">王老师</div>
          <div class="service-line">
            131-6151-0966
          </div>
        </div>
      </div>
    </div>
    <div class="aside-item try" @click="goToNeed">
      <div class="aside-imgs"></div>
      <div class="aside-txt">免费<br />试用</div>
    </div>
    <div class="aside-item down" @click="backtop">
      <div class="aside-imgs"></div>
      <div class="aside-txt">回到<br />顶部</div>
    </div>
  </div>
</template>

<script>
import services from "../assets/js/services"
export default {
  name: "Aside",
  components: {},
  data () {
    return {}
  },
  methods: {
    backtop () {
      var timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30)
    },
    goToNeed () {
      window.open(`${services.YXT_GW}/need`)
    }
  }
}
</script>

<style scoped>
.fixed-aside-box {
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 100;
    width: 55px;
    transform: translate(0, -50%);
    background: #ffffff;
    /* border: 1px solid #F5F7FA; */
    box-shadow: 0px 0px 8px 0px rgba(83, 83, 83, 0.2);
    border-radius: 4px;
}
.aside-item {
    background-color: #fff;
    height: 60px;
    text-align: center;
    cursor: pointer;
    position: relative;
}
.aside-item .aside-imgs {
    width: 100%;
    height: 60px;
    margin: 0 auto;
}
.aside-item .aside-txt {
    display: none;
    height: 60px;
    text-align: center;
}
.aside-item:hover {
    background: #f9e3e1;
}
.aside-item:hover .aside-txt {
    color: #df4233;
    display: flex;
    align-items: center;
    justify-content: center;
}
.aside-item:hover .aside-imgs {
    display: none;
}
.aside-item.wechat {
    border-radius: 4px 4px 0 0;
}
.aside-item.wechat .aside-imgs {
    background: url('../assets/image/common/wechat.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.phone .aside-imgs {
    background: url('../assets/image/common/telephone.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.try .aside-imgs {
    background: url('../assets/image/common/free-icon.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.down .aside-imgs {
    background: url('../assets/image/common/back-icon.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.down {
    border-radius: 0 0 4px 4px;
}
.aside-txt {
    font-size: 12px;
    color: #939292;
}
.position-sub {
    position: absolute;
    left: 0;
    top: -10px;
    padding: 15px;
    background-color: #fff;
    display: none;
    box-shadow: 0px 0px 7px 1px rgba(61, 119, 255, 0.12);
    border-radius: 8px 0 0 8px;
}
.position-sub.phone::after {
    width: 8px;
    height: 100%;
    content: '';
    display: inline-block;
    position: absolute;
    right: -4px;
    top: 0;
    z-index: 20;
    box-shadow: 0px 0px 8px 0px rgba(83, 83, 83, 0.2);
    border-radius: 4px;
}
.aside-item.wechat:hover .position-sub {
    display: block;
    left: -96px;
    top: 0;
    padding: 0px;
}
.aside-item.wechat .position-sub .position-img {
    width: 96px;
    height: 96px;
    background: url('../assets/image/common/sidebar-weixin.png') no-repeat center;
    background-size: 100% auto;
}
.aside-item.phone:hover .position-service {
    display: flex;
}
.position-service {
    width: 150px;
    position: absolute;
    left: -150px;
    top: 0;
    display: none;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 0px 8px 0px rgba(83, 83, 83, 0.2);
    border-radius: 4px;
    background-color: #fff;
    padding: 18px 15px;
    text-align: left;
}
.position-service .service-left .service-title {
    font-weight: bold;
    font-size: 16px;
    color: #212224;
}
.position-service .service-left .service-line {
    margin-top: 20px;
    font-size: 14px;
    color: #2b2c2e;
    line-height: 1;
    border-bottom: 6px solid #f9e3e1;
}
.position-service .service-right {
    width: 94px;
    margin-left: 17px;
}

.position-service .service-right img {
    width: 100%;
    height: auto;
}
</style>